import { getLocalStorageValue, setLocalStorageValue } from "@/shared/lib/local-storage.client";

const DEFAULT_IDEMPOTENCY_KEY = "idempotency-key";

export function getOrCreateIdempotencyKey(keyName = DEFAULT_IDEMPOTENCY_KEY) {
  if (typeof window === "undefined") {
    return crypto.randomUUID();
  }

  const existingKey = getLocalStorageValue(keyName);
  if (existingKey) {
    return existingKey;
  }

  const nextKey = crypto.randomUUID();
  setLocalStorageValue(keyName, nextKey);
  return nextKey;
}
